import { useQuery } from '@tanstack/react-query'
import { getPerson } from '@/lib/api/universe'
import { isUuid } from '@/lib/compute/universe'

/** One person by id, or null when they do not exist; ids that are not UUIDs never query. */
export function usePerson(id: string | undefined) {
  return useQuery({
    queryKey: ['universe', 'person', id],
    queryFn: () => getPerson(id!),
    enabled: !!id && isUuid(id),
    // Directory data changes rarely; 30s keeps back-navigation instant.
    staleTime: 30_000,
  })
}
